module.exports = __webpack_public_path__ + "img/bike.a014e578.png";